<script lang="ts">
	import { auth, db, storage } from '$lib/firebase';
	import { fade } from 'svelte/transition';
	import { FirebaseApp } from 'sveltefire';
	import '../../app.css';
</script>

{#await auth.authStateReady() then}
	<div in:fade={{ duration: 1000 }}>
		<FirebaseApp {auth} firestore={db} {storage}>
			<slot />
		</FirebaseApp>
	</div>
{/await}
